module.exports = __webpack_public_path__ + "images/bullet_plus_green.png";